
import { debug, george, observable, observer, React, theme, ui } from "aaa";
import { ContactsStore } from "stores/ContactsStore";
import { IPostContactResponse } from "types/contact";
import { isEmail } from "util/formValidations";
import { CancelButton } from "../util/CancelButton";
import { A11yRefocus } from "./A11yRefocus";
import { NativeModal } from "./NativeModal";
import { NativeRaisedButton } from "./NativeRaisedButton";
import { NewEmailSigning } from "./NewEmailSigning";
import { pushRoute } from "stores/RouterFunctions";
import trackingStore from "stores/TrackingStore";

interface IProps {
    show: boolean;
    contactsStore: ContactsStore;
    onClose: () => void;
}

type EmailType = "PRIVATE" | "COMPANY";

@observer
export class NewEmail extends React.Component<IProps, {}> {
    @observable signing = false;
    @observable contactResponse?: IPostContactResponse;

    @observable email = "";
    @observable emailType: EmailType = "PRIVATE";
    @observable invalidEmail = false;
    @observable mainContact: boolean = false;
    @observable loading = false;

    performRequest = async () => {
        try {
            this.loading = true;
            this.contactResponse = await this.props.contactsStore.addEmail(this.email, this.emailType, this.mainContact);
            this.signing = true;
        } catch (err) {
            debug.log("### error signing new email request");

            const emailError = err.response.errors?.find((errorItem: any) => errorItem.scope === "email.email");

            if (emailError) {
                this.invalidEmail = true;
            } else {
                pushRoute("/error");
            }
        } finally {
            this.loading = false;
        }
    }

    onSubmit = async () => {
        if (!this.loading) {
            debug.log("### submit", this.email, this.emailType, this.mainContact);
            await this.performRequest();
        }
    }

    renderModal() {
        if (this.signing) {
            return;
        }

        // Need this, because on some phones in some situations the dialog otherwise shrinks
        const DIALOG_HEIGHT = 400;

        return (
            <NativeModal
                open={this.props.show}
                paperStyle={{ borderRadius: theme.BORDER_RADIUS, minHeight: DIALOG_HEIGHT }}
                bodyStyle={{ borderTop: "none", borderBottom: "none", minHeight: DIALOG_HEIGHT }}
                aria-label={ui.__("email.addNew.title")}
            >
                {this.props.show && // Hide if not shown to take elements out of tabindex
                    <>
                        <A11yRefocus>
                            <CancelButton onClick={() => this.props.onClose()} showRight color={theme.customColors.georgeLightGrey} />
                        </A11yRefocus>
                        <br />

                        <george.SectionTitle> {ui.__("common.email")} </george.SectionTitle >
                        <george.TextField
                            onChange={(event: any, value: string) => this.email = value}
                            // validationError={ui.__("email.invalid")}
                            errorMessage={this.invalidEmail ? ui.__("email.invalid") : undefined}
                            aria-label={ui.__("common.email")}
                        />
                        <br />

                        <george.SectionTitle> {ui.__("contact.type")} </george.SectionTitle >
                        <george.DropDown
                            onChange={(event: any, index: number, value: string) => this.emailType = value as EmailType}
                            value={this.emailType}
                            aria-label={ui.__("a11y.chooseEmailType")}
                            items={[
                                { value: "PRIVATE", label: ui.__("contact.type.private") },
                                { value: "COMPANY", label: ui.__("contact.type.company") },
                            ]}
                        />
                        <br />

                        <george.Checkbox
                            label={ui.__("contact.main")}
                            onCheck={(event, checked) => this.mainContact = checked}
                            defaultChecked={this.mainContact}
                        />
                        <br />

                        <NativeRaisedButton
                            className="theme-action-button-background-color"
                            primary
                            disabled={!isEmail(this.email) || this.loading}
                            fullWidth
                            onClick={this.onSubmit}
                            style={{ height: 60, borderRadius: theme.BORDER_RADIUS }}
                            buttonStyle={{ borderRadius: theme.BORDER_RADIUS }}
                            labelStyle={{ fontWeight: "bold", textTransform: "none" }}
                            label={ui.__("common.save")}
                            isLoading={this.loading}
                        />
                    </>}
            </NativeModal >
        );
    }

    renderSigning() {
        if (!this.signing || !this.contactResponse) {
            return;
        }

        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 100,
                }}
            >
                <div
                    style={{
                        marginLeft: "auto",
                        marginRight: "auto",
                        position: "relative",
                        maxWidth: theme.MAX_APP_WIDTH,
                        height: "100vh",
                        background: "white"
                    }}
                >
                    <NewEmailSigning
                        contactsStore={this.props.contactsStore}
                        contactResponse={this.contactResponse}
                        onClose={() => this.signing = false}
                        onRetry={async () => { await this.performRequest(); }}
                        onSuccess={async () => {
                            try {
                                this.signing = false;

                                // Reload contacts
                                await this.props.contactsStore.load();
                                await trackingStore.trackEvent({ eventName: "emailAdded" });
                                this.props.onClose();
                            } catch (err) {
                                debug.log("### error loading contacts after new email");
                                pushRoute("/error");
                            }
                        }}
                    />
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                {this.renderModal()}
                {this.renderSigning()}
            </>
        );
    }

}




// WEBPACK FOOTER //
// ./src/components/common/NewEmail.tsx